<template>
  <InsightsTableContainer
    tooltip-key="data-table-general"
    download-id="overall-report-table"
    :error="error"
    class="table"
    :empty-data="emptyData || noWidgetData"
    :loading="loading"
    label="Overall Sources Data Table"
    :headers="tableHeaders"
    :rows="tableRows"
    :totals="tableTotals"
    show-passthrough-header
    :downloading="downloading"
    @download-csv="$emit('download-csv')"
  />
</template>

<script setup>
import InsightsTableContainer from '@/components/insights/table/InsightsTableContainer.vue';
import { computed } from 'vue';

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  emptyData: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tableRows: {
    type: Array,
    default: () => [],
  },
  tableTotals: {
    type: Array,
    default: () => [],
  },
  downloading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv']);

const noWidgetData = computed(() => !props.tableRows.length);

const tableHeaders = [
  'Applied',
  'Screening',
  'Assessment',
  'Offer',
  'Hired',
];
</script>
